import AppBar, { AppBarProps } from "@mui/material/AppBar";

export type { AppBarProps };

export default AppBar;
